import React from 'react';
import { Box, Center, Heading, Image, Text, VStack } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';

import chargerImg from '../../../assets/images/evse_charger_wait_for_ap.svg';
import { ArcButton } from '../../../common/components/ArcButton';
import { SlidingAnimationPageBase } from '../../../common/components/SlidingAnimationPageBase';
import { COMPONENT_MIN_HEIGHT, TOP_NAV_SPACING_AFFORDANCE } from '../../../common/constants';
import { useParamBackUrl } from '../../../common/hooks/use-param-back-url';
import { useSetupBackUrl } from './use-setup-back-url';

/* istanbul ignore next -- @preserve */
export function WaitForYellowLED() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { withSetupBackUrl } = useSetupBackUrl();
  const backURL = useParamBackUrl(withSetupBackUrl('../device-power-up-instructions?direction=back'));

  return (
    <SlidingAnimationPageBase title={t('Common.device setup')} backURL={backURL} includeTopNavHamButton px={4}>
      <Box display="flex" flexDirection="column" h={`calc(${COMPONENT_MIN_HEIGHT} - ${TOP_NAV_SPACING_AFFORDANCE})`}>
        <Center pt={10} pb={8}>
          <Box position="relative" w="48vw" h="48vw">
            <Image data-testid="yellow-led-image" src={chargerImg} alt="EV Charger Yellow LED" w="100%" h="100%" />
          </Box>
        </Center>

        <VStack align="stretch" spacing={2} mb={2}>
          <Heading fontSize={24} fontWeight={600} textAlign="center">
            {t('Set Up Hardware.wait for yellow led heading')}
          </Heading>
        </VStack>

        <VStack align="stretch" spacing={2}>
          <Text data-testid="yellow-led-text" textAlign="center">
            {t('Set Up Hardware.wait for yellow led text')}
          </Text>
        </VStack>

        <Center mt="auto" mb={5} flexDir={'column'}>
          <ArcButton
            data-testid="ev-charger-continue"
            onClick={() => navigate(withSetupBackUrl('../device-scan'))}
            w="100%"
            py={6}
            mt="auto"
            arcColor="#3DCD57"
          >
            {t('Common.continue')}
          </ArcButton>
        </Center>
      </Box>
    </SlidingAnimationPageBase>
  );
}
